import styled from "styled-components";

interface IVolanteRow {
  align?: any;
}
export const VolanteRow = styled.div<IVolanteRow>`
  ${(props) => `
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  background-color: ${(props) => props.theme.colors.white};
  align-items: center;
  border-radius: 1rem;
  display: grid;
  font-size: 1.4rem;
  font-weight: 500;
  grid-template-columns: 4.5rem 35rem repeat(5, 1fr) 10rem;
  margin-bottom: 1rem;
  padding: 0.9rem 0rem;
  text-align: center;

  .double-line-header {
    text-align: ${(props) => props.align};
    align-items: flex-start;
    margin-left: 1rem;
  }

  .double-line-header p {
    margin: 0.7rem 0 0 0;
  }

  .importer-id {
    ${(props) => `
      color: ${props.theme.colors.primaryBlue};
    `}
    font-size: 1.4rem;
    font-weight: 600;
  }

  .checkbox-volante {
    height: 1.5rem;
    width: 1.5rem;
  }

  .clickable-element {
    cursor: pointer;
  }
`;

interface IObservationDiv {
  observation?: string;
  clickable?: any;
}
export const ObservationDiv = styled.div<IObservationDiv>`
  ${(props) => {
    const observation = props.observation.toLowerCase();
    const cursor = props.clickable ? "pointer" : "auto";
    let color, backgroundColor;
    if (observation === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (observation === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else if (observation === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    }
    return `
      span {
        background-color: ${backgroundColor};
        color: ${color};
        cursor: ${cursor};
        font-size: 1.2rem;
        font-weight: 600;
        padding: 0.6rem;
      }
  `;
  }}
`;

// Status with tooltip
export const StatusSection = styled.div`
  cursor: pointer;
  display: inline-block;
  flex-direction: column;
  position: relative;

  &:hover .tooltip {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
`;

export const StatusBar = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

interface IStatusDiv {
  status?: string;
}
export const StatusDiv = styled.div<IStatusDiv>`
  ${(props) => {
    const status = props.status;
    let color, backgroundColor;
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor = props.theme.colors.supportYellow;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    }
    return `
      span {
        background-color: ${backgroundColor};
        color: ${color};
        font-size: 1.2rem;
        font-weight: 600;
        padding: 0.6rem;
      }
  `;
  }}
`;

interface IColoredLabel {
  isDateExpired?: any;
}
export const ColoredLabel = styled.div<IColoredLabel>`
  color: ${(props) =>
    props.isDateExpired
      ? props.theme.colors.accentRed
      : props.theme.colors.primaryBlue};
`;
